import React, { useEffect, useState } from "react";

import CustomRadio from "./CustomRadio";
import Label from "./Label";

import styles from "./Field.module.scss";

const RadioField = React.forwardRef(
  (
    {
      choiceClassName,
      className,
      errors,
      id,
      isInline,
      isRequired,
      label,
      defaultValue,
      description,
      type,
      choices,
      onChange,
    },
    ref
  ) => {
    const [value, setValue] = useState("");

    const inlineClass = isInline
      ? "d-xl-flex d-lg-flex d-md-flex flex-wrap d-block align-items-center"
      : "";
    const inlineChoiceClass = isInline
      ? "d-flex flex-xl-column flex-lg-column flex-md-column flex-row align-items-center align-items-xl-start align-items-lg-start align-items-md-start mr-5"
      : "";
    const inlineLabelClass = isInline ? "ml-xl-0 ml-lg-0 ml-md-0 ml-3" : "";
    const isInvalid = errors[id] ? "is-invalid" : "";

    useEffect(() => {
      setValue(defaultValue);
    }, [defaultValue]);

    const handleChange = (value) => {
      setValue(value);
      onChange(value);
    };

    const options = choices.map((choiceList, i) => (
      <div className={`${choiceClassName} ${inlineClass}`} key={i}>
        {choiceList.map(({ _id, name }) => (
          <div key={_id} className={inlineChoiceClass}>
            <CustomRadio
              type={type}
              id={_id}
              name={id}
              checked={value === _id}
              value={_id}
              ref={ref}
              onChange={handleChange}
            />
            <label htmlFor={_id} className={`${styles.choiceLabel} ${inlineLabelClass}`}>
              {name}
            </label>
          </div>
        ))}
      </div>
    ));

    return (
      <div className={`${className} ${styles.formGroup}`}>
        <div className={isInvalid}>
          <Label id={id} label={label} isRequired={isRequired} />
          <div className="row no-gutters">{options}</div>
        </div>
        {errors[id] && <div className="invalid-feedback">This field is required.</div>}
        <span className={`d-block mt-3 ${styles.description}`}>{description}</span>
      </div>
    );
  }
);

export default RadioField;
